export default {
    project: {},
    projects: [],
    comments: [],
};
